<template>
  <div id="app">
    <calculator></calculator>
  </div>
</template>

<script>
import Calculator from './components/Calculator'

export default {
  name: "app",
  data() {
    return {}
  }, 
  components: {
    Calculator,
  }
}
</script>

<style>
  
</style>
